import { Button, LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { BottomSheet, NoResults, Table } from '@/components'
import { useMobile, useToggle } from '@/hooks'
import useScheduledCommunicationTypes from '@/hooks/useScheduledCommunicationTypes/useScheduledCommunicationTypes'

import { CreateScheduledCommunicationTypeForm } from '../ScheduledCommunicationTypeForms/CreateScheduledCommunicationTypeForm'
import MobileScheduledCommunicationTypeCard from './MobileScheduledCommunicationTypeCard'
import { ScheduledCommunicationTypeListColumns } from './ScheduledCommunicationTypes.data'

export function ScheduledCommunicationTypes() {
  const { isShown: modalShown, toggle: modalToggle } = useToggle()
  const { data: scheduledCommunicationTypesData, refetch, isLoading } = useScheduledCommunicationTypes()

  const { isMobile } = useMobile()

  const data = useMemo(() => {
    return scheduledCommunicationTypesData && scheduledCommunicationTypesData?.scheduledCommunicationTypes.length > 0
      ? scheduledCommunicationTypesData?.scheduledCommunicationTypes
      : []
  }, [scheduledCommunicationTypesData])

  const columns = useMemo(() => {
    return ScheduledCommunicationTypeListColumns(refetch)
  }, [refetch])

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      <div className="mb-2 flex w-full items-center justify-between md:mb-8 md:flex-row">
        <h2 className="text-header-lg leading-120">Scheduled Communication Types</h2>

        <div className="hidden md:flex">
          <Button className="bg-action-primary" onClick={modalToggle} size="small">
            New
          </Button>
        </div>
      </div>
      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            data.length > 0 ? (
              data.map((scheduledCommunicationType) => (
                <MobileScheduledCommunicationTypeCard
                  key={scheduledCommunicationType.id}
                  scheduledCommunicationType={scheduledCommunicationType}
                />
              ))
            ) : (
              <NoResults />
            )
          ) : (
            <Table className={''} columns={columns as any} data={data} />
          )}
        </>
      )}
      <BottomSheet isVisible={modalShown} mobileFullHeight={true} onClose={modalToggle}>
        <CreateScheduledCommunicationTypeForm refetchOnSuccess={refetch} toggle={modalToggle} />
      </BottomSheet>
    </div>
  )
}
